import MessageModal from './MessageModal';

export default MessageModal;
